import classnames from 'classnames'
import React, { FC } from 'react'

import { festivalOfferPriceForCard } from '@src/quince-site-common/src/utils/festivalOffersUtility'
import { formatPrice } from '@src/quince-site-common/src/utils/formatPrice'

import { ProductTitleSectionProps } from './product-title-section'
import styles from './product-title-section.module.scss'

export const ProductPrice: FC<ProductTitleSectionProps> = props => {
  const { selectedCardVariant, productPrefixPriceClassName, priceClassName, productPriceClass } = props
  const salePrice = selectedCardVariant?.price.salePrice
  const showFrom = selectedCardVariant?.price.isRange

  const festivalPrice = selectedCardVariant ? festivalOfferPriceForCard(selectedCardVariant) : null

  return (
    <div
      className={classnames(styles.productPriceWrapper, productPriceClass, {
        [styles.festivalOfferWrapper]: festivalPrice,
      })}
    >
      <div className={classnames(styles.festivalOfferText)}>
        {showFrom && <div className={classnames(styles.productPrefixPrice, productPrefixPriceClassName)}>From</div>}
        {festivalPrice && (
          <div className={classnames(props.priceClassName, styles.festivalPrice)}>{formatPrice(festivalPrice)}</div>
        )}
      </div>
      <div className={classnames(priceClassName, styles.basePrice)}>{formatPrice(salePrice ?? 0)}</div>
    </div>
  )
}
